import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import TRANSLATIONS from "translations";
import STORAGE_KEYS from "constants/storage";
import LOCALES from "constants/locales";

const LanguageContext = React.createContext();
export default LanguageContext;


const getLangFromNavigator = () => {
	const nav_language = window.navigator.language?.split("-")?.[0] || "pl" 
	return LOCALES[ nav_language ] || "pl";
};

const getLangFromURL = () => {
	const lang = new URLSearchParams( window.location.search ).get( "lang" );
	return LOCALES.includes( lang ) ? lang : ""; 
}

const getLangFromStorage = () => localStorage.getItem( STORAGE_KEYS.LOCALE );


export const LanguageContextProvider = props => {
	
	const defineLang = () => getLangFromURL() || getLangFromStorage() || getLangFromNavigator();
	const history = useHistory();
	const [ locale, setLocale ] = useState( defineLang );

	const addLangParamInURL = () => {
		
		const new_locale = `lang=${ locale }`;
		const location = history.location;
		const { pathname, search, state } = location;

		const search_new = search 
			? /lang=/.test( search ) 
				? search.replace(/lang=[a-z00-9]+/, new_locale )
				: search + "&" + new_locale
			: "?" + new_locale;

		history.replace( pathname + search_new, state );
	}

	useEffect(() => {
		addLangParamInURL();

		document.querySelector("html").lang = locale;
		localStorage.setItem( STORAGE_KEYS.LOCALE, locale )
	}, [ locale ]);

	
	useEffect(() => { addLangParamInURL()}, [ history.location.pathname ])

	return (
		<LanguageContext.Provider value={{
			locale,
			translate: key => TRANSLATIONS?.[ key ]?.[ locale ] || key,
			changeLocale: l => {
				setLocale( l );
				localStorage.setItem( STORAGE_KEYS.LOCALE, l );
			}
		}}>
			{ props.children }
		</LanguageContext.Provider>
	)
}


export const useTranslate = () => {
	const { translate } = useContext( LanguageContext );	
	return translate;
}


export const useLocale = only_locale => {
	const { locale, changeLocale } = useContext( LanguageContext );	
	return only_locale ? locale : [ locale, changeLocale ];
}

